import { acceptState } from "./accept-state.ts"

export interface ZipMatch {
  zip_code: string
  city: string
  state: string
  state_supported: boolean
  display: string
}

/** Only the parts a match can speak for. An absent key leaves the field alone. */
export interface ZipFill {
  city?: string
  state?: string
}

/** ZIP or ZIP+4. Anything shorter is someone mid-type, not a failed lookup. */
const ZIP_RE = /^\d{5}(?:-\d{4})?$/

const isLookupZip = (value: string | null | undefined) =>
  ZIP_RE.test((value ?? "").trim())

/** An unmapped state leaves State as the user left it; the caller names the code. */
const zipFillFrom = (match: ZipMatch, knownStates: string[] = []): ZipFill => {
  const supported = match.state_supported && acceptState(match.state, knownStates)

  return {
    ...(match.city ? { city: match.city } : {}),
    ...(supported && match.state ? { state: match.state } : {})
  }
}

export { isLookupZip, zipFillFrom }
